import { withInstall, withNoopInstall } from '@element-plus/utils'

import Dropdown from './src/dropdown.vue'
import DropdownItem from './src/dropdown-item.vue'
import DropdownMenu from './src/dropdown-menu.vue'
import type { SFCWithInstall } from '@element-plus/utils'

export const ElDropdown = withInstall(Dropdown, {
  DropdownItem,
  DropdownMenu,
}) as SFCWithInstall<typeof Dropdown>
export default ElDropdown
export const ElDropdownItem = withNoopInstall(DropdownItem) as SFCWithInstall<
  typeof DropdownItem
>
export const ElDropdownMenu = withNoopInstall(DropdownMenu) as SFCWithInstall<
  typeof DropdownMenu
>
export * from './src/dropdown'
export * from './src/tokens'
